import { toast } from "react-toastify";
import Loader from "src/components/common/Loader/Loader";
import { useDeleteBusSimulate } from "src/services/react-query-apis/delete-bus-simulate";
import { useDeleteBusMutation } from "src/services/react-query-apis/delete-bus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { getCurrentMonth } from "src/services/auth/token";

const BusesDeleteConfirm = ({ busId, onClose }) => {
  const deleteBusSimulateQuery = useDeleteBusSimulate({
    id: busId,
    queryConfig: {
      staleTime: 0,
    },
  });

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      onClose();
    },
  };

  const deleteBusMutation = useDeleteBusMutation({
    mutationConfig,
  });

  if (deleteBusSimulateQuery.isFetching) {
    return <Loader message="データを取得中..." />;
  }

  if (deleteBusSimulateQuery.isError) {
    return (
      <>
        <div className="text-danger text-center mb-3 p-1 rounded bg-light border fw-bold">
          {deleteBusSimulateQuery.error.response.data.message}
        </div>
        <div className="text-end">
          <button className="btn btn-primary" onClick={onClose}>
            閉じる
          </button>
        </div>
      </>
    );
  }

  const { affected_bus_schedules, can_delete } =
    deleteBusSimulateQuery.data?.data;
  const hasAffectedBusSchedules = affected_bus_schedules.length > 0;

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column w-100">
        <div>
          <div
            className="alert alert-warning mb-3 text-center p-1"
            role="alert"
          >
            <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            この変更は{" "}
            {moment(getCurrentMonth())
              .add(1, "month")
              .format("YYYY年MM月")}{" "}
            から適用されます
          </div>
          {hasAffectedBusSchedules && (
            <div className="mb-3">
              <h6 className="text-center mb-3">参照しているバススケジュール</h6>
              <div className="alert alert-danger mb-2 p-2">
                {affected_bus_schedules.map(affectedBusSchedule => (
                  <div className="d-flex flex-column gap-1">
                    <div className="mb-1">
                      {affectedBusSchedule.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!can_delete && (
            <div className="alert alert-warning text-center mb-3" role="alert">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
              参照しているバススケジュールのバスを変更してから再度お試しください
            </div>
          )}
          <div className="d-flex gap-2 justify-content-end mt-3">
            <button className="btn btn-secondary px-4" onClick={onClose}>
              閉じる
            </button>
            <button
              className="btn btn-danger px-4"
              onClick={() => {
                deleteBusMutation.mutate(busId);
              }}
              disabled={deleteBusMutation.isPending || !can_delete}
            >
              {deleteBusMutation.isPending ? "処理中..." : "削除"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusesDeleteConfirm;
